
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"viewBox":"0 0 19 32","fill":"none","xmlns":"http://www.w3.org/2000/svg"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"d":"M16.123 0l-9.85 2.625L.5 20.25l4.415-1.875L1.18 31.5 18.5 9.375 12.047 10.5 16.123 0z","fill":"url(#paint0_linear)"}}),_c('defs',[_c('linearGradient',{attrs:{"id":"paint0_linear","x1":"18.5","y1":"15.75","x2":".71","y2":"13.816","gradientUnits":"userSpaceOnUse"}},[_c('stop',{attrs:{"stop-color":"#35BDD1"}}),_c('stop',{attrs:{"offset":"1","stop-color":"#D7DF38"}})])])])
          )
        }
      }
    